// Side-effect module — must be imported BEFORE any module that defines
// `gql` documents (i.e. before graphql-common is loaded transitively).
// Admin imports queries from both `graphql-common` (admin codegen) and
// `@lib/graphql-common` (lib codegen); each generated file registers the
// same fragment names (attachmentFragment, edmDocumentation*, etc.),
// which makes graphql-tag log "fragment with name X already exists".
import { disableFragmentWarnings } from '@apollo/client';

disableFragmentWarnings();
